import { createAction, props } from '@ngrx/store';

export const updateUser = createAction('[Register] update user', props<{user: any}>());
export const updateError = createAction('[Register] update error', props<{error: any}>());
export const updatePopover = createAction('[Register] update popover', props<{popover: any}>());
export const updateSaving = createAction('[Register] update saving', props<{saving: any}>());
export const saveData = createAction('[Register] save data');
export const updateCaptchaToken = createAction('[Register] update Captcha token', props<{captchaToken: any}>());
